import { Attributes } from '@leverege/ui-attributes';
const getSearchableAttributes = (bp, searchableAttrNames) => {
  const attrs = Attributes.getAttributesFor(bp.type);
  const attrFilter = attr => {
    if (searchableAttrNames) {
      return searchableAttrNames.includes(attr.name);
    }
    return attr?.blueprint?.field != null && attr?.blueprint?.attribute?.searchType === 'string';
  };
  return attrs.filter(attrFilter);
};
function createChildFilter(relationship) {
  const childToParentPath = relationship?.attribute?.model?.childPath;
  const searchableAttrNames = relationship?.attribute?.metadata?.pairing?.search?.tag?.searchableAttrNames;
  const childSearchableFields = getSearchableAttributes(relationship?.blueprint, searchableAttrNames);
  return getFilterFunc(childToParentPath, childSearchableFields);
}
function createParentFilter(relationship) {
  const parentToChildPath = relationship?.attribute?.path;
  const searchableAttrNames = relationship?.attribute?.metadata?.pairing?.search?.asset?.searchableAttrNames;
  const parentSearchableFields = getSearchableAttributes(relationship.parentBlueprint, searchableAttrNames);
  return getFilterFunc(parentToChildPath, parentSearchableFields);
}
function createAssetByTagFilter(relationship) {
  const parentToChildPath = relationship?.attribute?.path;
  const field = `data/${parentToChildPath}/id`;
  return tagImagineId => ({
    type: 'expression',
    kind: 'queryString',
    field,
    value: tagImagineId
  });
}
const create = relationship => {
  const {
    pair: childFilter,
    unpair: childFilterUnpair
  } = createChildFilter(relationship);
  const {
    pair: parentFilter,
    unpair: parentFilterUnpair
  } = createParentFilter(relationship);
  return {
    childFilter,
    childFilterUnpair,
    parentFilter,
    parentFilterUnpair,
    assetByTagFilter: createAssetByTagFilter(relationship)
  };
};
function getFilterFunc(relationshipPath, searchableFields) {
  function searchFieldsMatch(value) {
    return searchableFields.map(attr => ({
      type: 'expression',
      kind: 'queryString',
      analyzeWildcard: true,
      ignoreCase: true,
      field: attr.blueprint.field,
      value: `*${value}*`
    }));
  }
  const pair = value => ({
    type: 'logical',
    operator: 'and',
    conditions: [{
      type: 'logical',
      operator: 'or',
      conditions: searchFieldsMatch(value)
    }, {
      type: 'logical',
      operator: 'and',
      conditions: [{
        not: true,
        type: 'exists',
        field: `data/${relationshipPath}/id`
      }]
    }]
  });
  const unpair = value => ({
    type: 'logical',
    operator: 'and',
    conditions: [{
      type: 'logical',
      operator: 'or',
      conditions: searchFieldsMatch(value)
    }, {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'exists',
        field: `data/${relationshipPath}/id`
      }]
    }]
  });
  return {
    pair,
    unpair
  };
}
const toExport = {
  create
};
export default toExport;